export default __webpack_public_path__ + "static/media/heart-calendar-icon.02d5c839.svg";